// ── CPF ──────────────────────────────────────────────────────────────────────
export const validarCPF = (cpf) => {
  const n = cpf.replace(/\D/g, '');
  if (n.length !== 11 || /^(\d)\1{10}$/.test(n)) return false;
  const calc = (len) => {
    let sum = 0;
    for (let i = 0; i < len; i++) sum += parseInt(n[i]) * (len + 1 - i);
    const rest = 11 - (sum % 11);
    return rest >= 10 ? 0 : rest;
  };
  return calc(9) === parseInt(n[9]) && calc(10) === parseInt(n[10]);
};

// ── CNPJ ─────────────────────────────────────────────────────────────────────
export const validarCNPJ = (cnpj) => {
  const n = cnpj.replace(/\D/g, '');
  if (n.length !== 14 || /^(\d)\1{13}$/.test(n)) return false;
  const soma = (str, pesos) => str.split('').slice(0, pesos.length).reduce((acc, d, i) => acc + parseInt(d) * pesos[i], 0);
  const dig = (s) => { const r = s % 11; return r < 2 ? 0 : 11 - r; };
  const d1 = dig(soma(n, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]));
  const d2 = dig(soma(n, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]));
  return d1 === parseInt(n[12]) && d2 === parseInt(n[13]);
};

// ── Auto-detect CPF ou CNPJ ───────────────────────────────────────────────────
export const validarCpfCnpj = (value) => {
  const n = value.replace(/\D/g, '');
  if (n.length === 11) return validarCPF(n);
  if (n.length === 14) return validarCNPJ(n);
  return null; // ainda incompleto — null = não validar
};

// ── Masks ─────────────────────────────────────────────────────────────────────
export const formatarCPF = (value) => {
  const n = value.replace(/\D/g, '').slice(0, 11);
  return n.replace(/^(\d{3})(\d{3})(\d{3})(\d{0,2}).*$/, (_, a, b, c, d) =>
    d ? `${a}.${b}.${c}-${d}` : c ? `${a}.${b}.${c}` : b ? `${a}.${b}` : a
  );
};

export const formatarCNPJ = (value) => {
  const n = value.replace(/\D/g, '').slice(0, 14);
  return n.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2}).*$/, (_, a, b, c, d, e) =>
    e ? `${a}.${b}.${c}/${d}-${e}` : d ? `${a}.${b}.${c}/${d}` : c ? `${a}.${b}.${c}` : b ? `${a}.${b}` : a
  );
};

export const formatarCpfCnpj = (value) => {
  const n = value.replace(/\D/g, '');
  return n.length <= 11 ? formatarCPF(value) : formatarCNPJ(value);
};

export const formatarCNPJOnly = (value) => {
  return formatarCNPJ(value);
};

// ── Helper para mensagem de erro ──────────────────────────────────────────────
export const mensagemCpfCnpj = (value) => {
  const n = value.replace(/\D/g, '');
  if (!n) return null;
  if (n.length < 11) return 'Número incompleto';
  if (n.length === 11 && !validarCPF(n)) return 'CPF inválido';
  if (n.length > 11 && n.length < 14) return 'Número incompleto';
  if (n.length === 14 && !validarCNPJ(n)) return 'CNPJ inválido';
  return null;
};

export const mensagemCNPJ = (value) => {
  const n = value.replace(/\D/g, '');
  if (!n) return null;
  if (n.length < 14) return 'CNPJ incompleto (14 dígitos)';
  if (!validarCNPJ(n)) return 'CNPJ inválido';
  return null;
};
